import React from 'react';
import { IconProps } from '../../icons/types';

const CasesIcon: React.FC<IconProps> = props => {
  const { fillColor = 'var(--bg-primary)', width = 24, height = 24 } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.8102 20.99H4.36016C4.2497 20.99 4.16016 20.9005 4.16016 20.79V5.91"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M18.9701 3.01001H7.15013C7.03968 3.01001 6.95013 3.09955 6.95013 3.21001V18C6.95013 18.1105 7.03968 18.2 7.15013 18.2H18.9701C19.0806 18.2 19.1701 18.1105 19.1701 18V3.21001C19.1701 3.09955 19.0806 3.01001 18.9701 3.01001Z"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default CasesIcon;
